import type { IconColor, IconID } from '@common/Icon/Icon';
import { Icon } from '@common/Icon/Icon';
import type { Argument } from 'classnames/dedupe';
import classNames from 'classnames/dedupe';

export interface IconButtonProps {
  icon: IconID;
  iconColor?: IconColor;
  onClick?: () => void;
  ariaLabel?: string;
  title?: string;
  primary?: boolean;
  size?: number; // see tailwind for w- & h- sizes
  className?: Argument;
  testId?: string;
  disabled?: boolean;
  text?: string;
}

export const IconButton = ({
  icon,
  iconColor,
  onClick,
  ariaLabel,
  title = '',
  primary = true,
  size = 6, // see tailwind for w- & h- sizes
  className = '',
  testId,
  disabled,
  text,
}: IconButtonProps) => (
  <div className="group">
    <button
      aria-label={ariaLabel}
      type="button"
      data-testid={testId ?? 'icon-button'}
      title={title}
      onClick={onClick}
      disabled={disabled}
      className={classNames(
        'p-3',
        'border-none',
        'outline-none',
        'focus:outline-none',
        primary ? 'text-gray-500 hover:bg-black hover:text-white group-hover:text-white' : 'hover:bg-none',
        className
      )}
    >
      <Icon size={size} id={icon} primary={primary} color={iconColor} />
      {text && <span className="ml-1">{text}</span>}
    </button>
  </div>
);
